import api from 'api';

export const getIWatchAccounts = (params) => {
  return api.get('/iwatch_accounts', params, 'bearer');
};

export const getIWatchAccount = (id, params) => {
  return api.get(`/iwatch_accounts/${encodeURIComponent(id)}`, params, 'bearer');
};

export const getUserIWatchAccounts = (params) => {
  return api.get('/user_iwatch_accounts', params, 'bearer');
};

export const createUserIWatchAccount = (body) => {
  return api.post('/user_iwatch_accounts', body, 'bearer');
};

export const deleteUserIWatchAccount = (id) => {
  return api.delete(`/user_iwatch_accounts/${encodeURIComponent(id)}`, 'bearer');
};
